import {
  LOG_IN,
  REGISTER,
  FORGOT_PASS,
  SET_USER_LOADING,
  RESET_PASS,
  CONFIRM_EMAIL,
  RESEND_EMAIL,
  SUBSCRIPTION,
  GET_BOOKMARKS,
  CREATE_BOOKMARK,
  SET_BOOKMARK_LOADING,
  DELETE_BOOKMARK,
  DELETE_BOOKMARKS,
  GET_CARDS,
  ADD_CARD,
  UPDATE_CARD,
  UPDATE_DEFAULT_CARD,
  DELETE_CARD,
  SET_CARD_ERROR,
  GET_TRANSACTIONS,
  UPDATE_USER,
  UPDATE_USER_ERROR,
  SUBSCRIPTION_ERROR,
  CLEAR_SUBSCRIPTION_ERROR,
  CLEAR_UPDATE_PASS,
  UPDATE_PASS,
  LOG_OUT,
  CREATE_COMMENT,
  INVITE_USER,
  INVITE_USER_ERROR,
  GET_USERS_BY_CLIENT_ID,
  DELETE_USER_CLIENT,
  SET_USER_CLIENT_ERROR,
  UPDATE_CLIENT_ROLE,
  REINVITE_USER,
  REINVITE_USER_ERROR,
  SEND_ENQUIRY,
  SUBSCRIPTION_UPDATE,
  CREATE_CLIENT_SUBSCRIPTION,
  UPDATE_CLIENT_SUBSCRIPTION,
} from './userTypes';

const initialState = {
  loading: false,
  user: null,
  userError: null,
  changePassword: null,
  subscriptionError: null,
  bookmarks: null,
  bookmarkLoading: 0,
  cards: null,
  cardError: null,
  transactions: null,
  // usersByClient: null,
  // usersByClientError: null,
  newUser: null,
  subscriptionUpdate: null,
  enquiry: null,
};

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOG_OUT:
      return {
        loading: false,
        user: 'logged out',
        userError: null,
        changePassword: null,
        subscriptionError: null,
        bookmarks: null,
        bookmarkLoading: 0,
        cards: null,
        cardError: null,
        transactions: null,
        // usersByClient: null,
        // usersByClientError: null,
        newUser: null,
        subscriptionUpdate: null,
        enquiry: null,
      };
    case LOG_IN:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    case UPDATE_USER:
      return {
        ...state,
        user: action.payload,
        userError: null,
        // bookmarks: null,
        cards: null,
        transactions: null,
        loading: false,
      };
    case UPDATE_USER_ERROR:
      return {
        ...state,
        userError: action.payload,
        loading: false,
      };
    case UPDATE_PASS:
      return {
        ...state,
        changePassword: action.payload,
        loading: false,
      };
    case CLEAR_UPDATE_PASS:
      return {
        ...state,
        changePassword: null,
        loading: false,
      };
    case REGISTER:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    case SUBSCRIPTION:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    case SUBSCRIPTION_ERROR:
      return {
        ...state,
        subscriptionError: action.payload,
        loading: false,
      };
    case CLEAR_SUBSCRIPTION_ERROR:
      return {
        ...state,
        subscriptionError: null,
      };
    case GET_BOOKMARKS:
      return {
        ...state,
        bookmarks: action.payload,
        bookmarkLoading: state.bookmarkLoading - 1,
      };
    case DELETE_BOOKMARK:
      return {
        ...state,
        bookmarks: action.payload,
        bookmarkLoading: state.bookmarkLoading - 1,
      };
    case DELETE_BOOKMARKS:
      return {
        ...state,
        bookmarks: action.payload,
        bookmarkLoading: state.bookmarkLoading - 1,
      };
    case CREATE_BOOKMARK:
      return {
        ...state,
        bookmarks: action.payload,
        bookmarkLoading: state.bookmarkLoading - 1,
      };
    case SET_BOOKMARK_LOADING:
      return {
        ...state,
        bookmarkLoading: state.bookmarkLoading + 1,
      };
    case CREATE_COMMENT:
      return {
        ...state,
        loading: false,
      };
    case RESEND_EMAIL:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    case CONFIRM_EMAIL:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    case FORGOT_PASS:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    case RESET_PASS:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    case GET_CARDS:
      return {
        ...state,
        cards: action.payload,
        loading: false,
      };
    case ADD_CARD:
      return {
        ...state,
        cards: action.payload,
        cardError: null,
        loading: false,
      };
    case UPDATE_DEFAULT_CARD:
      return {
        ...state,
        cards: null,
        cardError: null,
      };
    case UPDATE_CARD:
      return {
        ...state,
        cards: null,
        cardError: null,
      };
    case DELETE_CARD:
      return {
        ...state,
        cards: action.payload,
        cardError: null,
        loading: false,
      };
    case SET_CARD_ERROR:
      return {
        ...state,
        cardError: action.payload,
        loading: false,
      };
    case GET_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload,
        loading: false,
      };
    case SET_USER_LOADING:
      return {
        ...state,
        loading: true,
      };
    case CREATE_CLIENT_SUBSCRIPTION:
      return {
        ...state,
        // user: action.payload,
        loading: false,
      };
    case UPDATE_CLIENT_SUBSCRIPTION:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    case INVITE_USER:
      return {
        ...state,
        usersByClient: action.payload,
        usersByClientError: null,
        loading: false,
      };
    case INVITE_USER_ERROR:
      return {
        ...state,
        usersByClientError: action.payload,
        loading: false,
      };
    case GET_USERS_BY_CLIENT_ID:
      return {
        ...state,
        usersByClient: action.payload,
        loading: false,
      };
    case DELETE_USER_CLIENT:
      return {
        ...state,
        usersByClient: action.payload,
        usersByClientError: null,
        loading: false,
      };
    case SET_USER_CLIENT_ERROR:
      return {
        ...state,
        usersByClientError: action.payload,
        loading: false,
      };
    case UPDATE_CLIENT_ROLE:
      return {
        ...state,
        usersByClient: null,
        usersByClientError: null,
      };
    case REINVITE_USER:
      return {
        ...state,
        usersByClient: action.payload,
        usersByClientError: null,
        loading: false,
      };
    case REINVITE_USER_ERROR:
      return {
        ...state,
        usersByClientError: action.payload,
        loading: false,
      };
    case SEND_ENQUIRY:
      return {
        ...state,
        enquiry: action.payload,
        loading: false,
      };
    case SUBSCRIPTION_UPDATE:
      return {
        ...state,
        subscriptionUpdate: action.payload,
        loading: false,
      };
    default:
      return { ...state };
  }
};

export default UserReducer;
